/**
 *
 * @param text {string} - 検索文字列
 *
 * @returns 単語毎に分割した文字列、半角・全角スペースで分割
 *
 */
export const splitWordsConverter = (text: string): Array<string> => {
	if (!text) return [];

	// 単語毎に分割
	return (
		text
			.trimStart()
			.trimEnd()
			.toLowerCase()
			// eslint-disable-next-line no-irregular-whitespace
			.split(/[\s　]+/)
			.filter((word) => word !== "")
	);
};
